module.exports = __webpack_public_path__ + "media/gun_4.8fe9699c.mp3";